import React, { useState, useEffect, useRef, useMemo } from "react";
import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
import { isRegistered } from "services/self";
import { updatePrivateApisList } from "services/api-catalog";
import SwaggerLayoutPlugin from "components/SwaggerUiLayout";
import PageWithSidebar from "components/PageWithSidebar";
import AsyncApisMenu from "components/AsyncApisMenu";
import { useParams } from "react-router";
import { store } from "services/state.js";
import { Header, Container, Segment, Loader } from "semantic-ui-react";

function PrivateAPIs() {
  const containerRef = useRef();
  const swaggerUiInstanceRef = useRef();
  const [privateApisList, setPrivateApisList] = useState(
    store.privateApiList.privateApis,
  );
  const loaded = store.privateApiList.loaded;
  const { "*": directory } = useParams();
  const [apiDirectory, setApiDirectory] = useState(
    directory ? directory.split("/") : [],
  );
  const [apiContent, setApiContent] = useState(null);

  useEffect(() => {
    async function fetchData() {
      await updatePrivateApisList(true);
      setPrivateApisList(store.privateApiList.privateApis);
    }
    fetchData();
  }, []);

  useMemo(() => {
    setApiDirectory(directory ? directory.split("/") : []);
  }, [directory]);

  useMemo(() => {
    let content = null;
    const displayContent = (apiList, index) => {
      apiList.forEach((api) => {
        if (apiDirectory[index] === api.title) {
          api.content && Array.isArray(api.content)
            ? displayContent(api.content, index + 1)
            : (content = api);
        }
      });
    };
    if (loaded && apiDirectory.length > 0) {
      displayContent(privateApisList, 0);
      setApiContent(content);
    }
  }, [apiDirectory, privateApisList, loaded]);

  useEffect(() => {
    if (containerRef.current && apiContent) {
      const swaggerUiConfig = {
        domNode: containerRef.current,
        plugins: [SwaggerLayoutPlugin],
        supportedSubmitMethods: [],
        spec: apiContent,
      };
      if (isRegistered() && process.env.REACT_APP_ENVIRONMENT_NAME !== "prod") {
        delete swaggerUiConfig.supportedSubmitMethods;
      }
      swaggerUiInstanceRef.current = SwaggerUI(swaggerUiConfig);
    }
  }, [apiContent]);

  return (
    <PageWithSidebar
      sidebarContent={
        loaded ? (
          <AsyncApisMenu
            apiDirectory={apiDirectory}
            data={privateApisList}
            sidebarTitle={"Private APIs"}
            url={"private-apis"}
          />
        ) : (
          <Loader active />
        )
      }
      SidebarPusherProps={{ className: "swagger-section" }}
    >
      {directory && apiContent ? (
        <div
          className="swagger-ui-wrap"
          ref={containerRef}
          style={{ padding: "0 20px" }}
        />
      ) : (
        <Container fluid style={{ padding: "2em" }}>
          <Header as="h1">Private APIs</Header>
          <Segment>
            <p>
              Visualization of private REST APIs that are accessible only within
              the internal network, providing secure access to internal services
              and resources.
            </p>
          </Segment>
        </Container>
      )}
    </PageWithSidebar>
  );
}

export default PrivateAPIs;
